/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserLikesResult } from '../../models/get-user-likes-result';

export interface GetUserLikes$Params {}

export function getUserLikes(
  http: HttpClient,
  rootUrl: string,
  params?: GetUserLikes$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetUserLikesResult>> {
  const rb = new RequestBuilder(rootUrl, getUserLikes.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserLikesResult>;
    }),
  );
}

getUserLikes.PATH = '/Authentication/user-likes';
